// extracted by mini-css-extract-plugin
export default {"tooltip":"uR-z","arrow":"vR-z"};